module.exports = __webpack_public_path__ + "static/media/admin_plugin_sap.7cdb0374.svg";